// import React, { useState, useEffect } from "react";
// import PropTypes from "prop-types";
// import { alpha } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Toolbar from "@mui/material/Toolbar";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";

import "components/Results/PrivateLeaderboard/PrivateLeaderboard.css";

import datetimeConverter from "utils/datetimeConverter";
import { BenchmarkRecordRow } from "components/Results/BenchmarkRecords";

const PrivateLeaderboardTable = (props) => {
  /* 
   * Function to load leaderboard records and render the private leaderboard table component. 
  */
  const { results, mode, tableName } = props;
  return (
    <Box sx={{ paddingBottom: "20px" }}>
      <Paper>
        {/* TOOLBAR ON TOP OF THE TABLE */}
        <Toolbar
          sx={{
            pl: { sm: 2 },
            pr: { xs: 1, sm: 1 },
          }}
        >
          <Typography
            sx={{ flex: "1 1 100%", textAlign: "date" }}
            variant="h6"
            id="tableTitle"
            component="div"
          >
            <b>{tableName}</b>
          </Typography>
        </Toolbar>

        {/* TABLE */}
        <TableContainer style={{ overflowX: "initial" }}>
          <Table aria-labelledby="tableTitle" size="small">
            {/* TABLE HEADERS */}
            <TableHead
              style={{
                position: "sticky",
                top: 0,
                zIndex: 3,
                width: "100%",
                backgroundColor: "#F2F2F2",
              }}
            >
              <TableRow>
                <TableCell
                  sx={{
                    fontWeight: "bold",
                    borderBottom: "3px solid grey",
                    width: 30,
                  }}
                >
                  <TableHead>Estimated Rank</TableHead>
                </TableCell>
                <TableCell
                  sx={{
                    fontWeight: "bold",
                    borderBottom: "3px solid grey",
                  }}
                >
                  <TableHead>Team Name + Total Submissions</TableHead>
                </TableCell>
                <TableCell
                  sx={{
                    fontWeight: "bold",
                    borderBottom: "3px solid grey",
                    width: 30,
                  }}
                >
                  <TableHead>Harmonic Mean Private (ASR)</TableHead>
                </TableCell>
                <TableCell
                  sx={{
                    fontWeight: "bold",
                    borderBottom: "3px solid grey",
                    width: 30,
                  }}
                >
                  <TableHead>Average Token Length Ratio</TableHead>
                </TableCell>
                <TableCell
                  sx={{
                    fontWeight: "bold",
                    borderBottom: "3px solid grey",
                    width: 30,
                  }}
                >
                  <TableHead>Secret Model 1 (ASR)</TableHead>
                </TableCell>
                <TableCell
                  sx={{
                    fontWeight: "bold",
                    borderBottom: "3px solid grey",
                    width: 30,
                  }}
                >
                  <TableHead>Secret Model 2 (ASR)</TableHead>
                </TableCell>
                <TableCell
                  sx={{
                    fontWeight: "bold",
                    borderBottom: "3px solid grey",
                    width: 30,
                  }}
                >
                  <TableHead>Harmonic Mean Public (ASR)</TableHead>
                </TableCell>
                <TableCell
                  sx={{
                    fontWeight: "bold",
                    borderBottom: "3px solid grey",
                    width: 30,
                  }}
                >
                  <TableHead>Llama-2-7b-chat-hf (ASR)</TableHead>
                </TableCell>
              </TableRow>
            </TableHead>

            {/* TABLE BODY */}
            <TableBody>
              {results?.map((row, index) => {
                const labelId = `enhanced-table-checkbox-${index}`;

                if (!row.team_name) {
                  // if record has no team name, it's a benchmark score (FOR PRIVATE_BENCHMARK_RECORDS)
                  return (
                    <BenchmarkRecordRow row={row} leaderboardType={"private"} />
                  );
                }

                return (
                  <TableRow role="checkbox" tabIndex={-1} key={row?.team_id}>
                    <TableCell id={labelId}>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        {row?.ranking}
                      </div>
                    </TableCell>
                    <TableCell id={labelId}>
                      <div style={{ paddingTop: "10px", width: 450 }}>
                        <div style={{ color: "#ae2514" }}>
                          <b>{row?.team_name}</b>
                        </div>
                        <div
                          style={{
                            color: "grey",
                            display: "flex",
                            flexDirection: "column",
                            marginTop: "5px",
                          }}
                        >
                          {mode === 2 && (
                            <div style={{ color: "black" }}>
                              {row?.picked_results}
                              {" Selected Submission(s)"}
                            </div>
                          )}
                          <div>
                            {row.successful_attempts}
                            {" Submission(s)"}
                          </div>
                          <div>
                            Best public score submission on:{" "}
                            {datetimeConverter(row.created_date)}
                          </div>
                        </div>
                      </div>
                    </TableCell>
                    <TableCell>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          marginTop: "3px",
                        }}
                      >
                        {row?.asr_hmean_private}
                      </div>
                    </TableCell>
                    <TableCell>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          marginTop: "3px",
                        }}
                      >
                        {row?.avg_token_length_ratio}
                      </div>
                    </TableCell>
                    <TableCell>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          marginTop: "3px",
                        }}
                      >
                        {row?.asr_secret_model_1}
                      </div>
                    </TableCell>
                    <TableCell>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          marginTop: "3px",
                        }}
                      >
                        {row?.asr_secret_model_2}
                      </div>
                    </TableCell>
                    <TableCell>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          marginTop: "3px",
                        }}
                      >
                        {row?.asr_hmean_public}
                      </div>
                    </TableCell>
                    <TableCell>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          marginTop: "3px",
                        }}
                      >
                        {row?.asr_llama}
                      </div>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </Box>
  );
};

export { PrivateLeaderboardTable };
